import React, { useRef } from 'react';
import AboutBanner from '../../components/AboutBanner';
import HeaderSection from '../../components/HeaderSection';
import Navbar from '../../components/Navbar';
import AboutPersonalized from '../../components/AboutPersonalized';
import Team from '../../components/Team';
import AboutNutritionSection from '../../components/AboutNutritionSection';
import Footer from '../../components/Footer';
import Founder from '../../components/Founder';
import AboutJourney from '../../components/AboutJourney';
import AboutBenefit from '../../components/AboutBenefit';
import Timeline from '../../components/TimeLine';

const AboutUS = () => {
     const appointmentRef = useRef(null);
    
      const scrollToAppointment = () => {
        if (appointmentRef.current) {
          appointmentRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      };
    return (
        <div >
            <AboutBanner />
            <Timeline />
            <AboutPersonalized />
            <Team />
            <AboutNutritionSection />
            <AboutJourney />
            <AboutBenefit />
            <Founder />
        </div>
    );
}

export default AboutUS;
